import { v4 as uuidv4 } from 'uuid';
import apiURL from './apiURL';
import { NotificationManager } from 'react-notifications';
import { authFetch } from "../../utils/authFetch";

const fetch = authFetch;

// types of action
const Types = {
	ADVENT_CALENDAR_NOTIFICATION_ADD: "ADVENT_CALENDAR_NOTIFICATION_ADD",
	ADVENT_CALENDAR_NOTIFICATION_CLOSE: "ADVENT_CALENDAR_NOTIFICATION_CLOSE",
    ADVENT_CALENDAR_SET_MODAL: 'ADVENT_CALENDAR_SET_MODAL',
	ADVENT_CALENDAR_LOADING_GIFTS: "ADVENT_CALENDAR_LOADING_GIFTS",
	ADVENT_CALENDAR_LOADED_GIFTS: "ADVENT_CALENDAR_LOADED_GIFTS",
	ADVENT_CALENDAR_LOADING_RECENT_GIFTS: "ADVENT_CALENDAR_LOADING_RECENT_GIFTS",
	ADVENT_CALENDAR_LOADED_RECENT_GIFTS: "ADVENT_CALENDAR_LOADED_RECENT_GIFTS",
	ADVENT_CALENDAR_SAVING_GIFT: "ADVENT_CALENDAR_SAVING_GIFT",
	ADVENT_CALENDAR_SET_TERMS_MODAL: "ADVENT_CALENDAR_SET_TERMS_MODAL",
	ADVENT_CALENDAR_SET_SIGNIN_MODAL: "ADVENT_CALENDAR_SET_SIGNIN_MODAL",
};

const sendNotification =  (notification) => ({
	type: Types.ADVENT_CALENDAR_NOTIFICATION_ADD,
	notification
});

const closeNotification =  (id) => ({
	type: Types.ADVENT_CALENDAR_NOTIFICATION_CLOSE,
	id
});

const addNotification = (notification,timeout) => {
	return (dispatch, getState) => {

		if (!notification.id){
			notification.id = uuidv4();
		}

		dispatch(sendNotification(notification))

		if (timeout){
			// if there is a timeout automatically remove the notification after some time
			setTimeout(() => dispatch(closeNotification(notification.id)) ,timeout)
		}

	}
}

const setCalendarModal = (value) => ({
	type: Types.ADVENT_CALENDAR_SET_MODAL,
	value,
});

const loadingMyGifts = (status) => ({
	type: Types.ADVENT_CALENDAR_LOADING_GIFTS,
	status,
});

const loadedMyGifts = (items) => ({
	type: Types.ADVENT_CALENDAR_LOADED_GIFTS,
	items,
});

const getMyGifts = (year) => {
	return (dispatch, getState) => {

		const state = getState();

		if (state.adventCalendar.loadingMy) {
			return;
		}

		dispatch(loadingMyGifts(true));

		fetch(apiURL + `/settings/adventCalendar/myGifts/${year}`, {
			credentials: 'include',
			method: 'GET',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			},
		})
			.then(response => response.json())
			.then(data => {
				dispatch(loadedMyGifts(data?.lastGifted || []));
			})
			.catch(err => {
				console.error(err);
				NotificationManager.error("Something went wrong!", "Error Loading Gifts");
				dispatch(loadingMyGifts(false));
			});
	}
}

const loadingRecentGifts = (status) => ({
	type: Types.ADVENT_CALENDAR_LOADING_RECENT_GIFTS,
	status,
});

const loadedRecentGifts = (payload) => ({
	type: Types.ADVENT_CALENDAR_LOADED_RECENT_GIFTS,
	payload,
});

const getRecentGifts = (year) => {
	return (dispatch, getState) => {

		const state = getState();

		if (state.adventCalendar.loadingRecent) {
			return;
		}

		dispatch(loadingRecentGifts(true));

		fetch(apiURL + `/settings/adventCalendar/lastGifted/${year}`, {
			credentials: 'include',
			method: 'GET',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			},
		})
			.then(response => response.json())
			.then(data => {
				dispatch(loadedRecentGifts(data));
			})
			.catch(err => {
				console.error(err);
				NotificationManager.error("Something went wrong!", "Error Loading Gifts");
				dispatch(loadingRecentGifts(false));
			});
	}
}

const savingUserGift = (status) => ({
	type: Types.ADVENT_CALENDAR_SAVING_GIFT,
	status,
});

const saveUserGift = ({ itemId, boxNumber, location, answers }) => {
	return (dispatch, getState) => {

		const state = getState();

		if (state.adventCalendar.savingUserGift) {
			return;
		}

		dispatch(savingUserGift(true));

		fetch(apiURL + "/settings/adventCalendar/saveUserGift", {
			credentials: 'include',
			method: 'POST',
			body: JSON.stringify({ itemId, boxNumber, location, answers }),
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			},
		})
			.then(response => response.json())
			.then(data => {
				dispatch(savingUserGift(false));
			})
			.catch(err => {
				console.error("ERROR SAVING GIFT");
				console.error(err);
				NotificationManager.error("Something went wrong!", "Error Loading Gifts");
				dispatch(savingUserGift(false));
			});
	}
}

const getTermsModal = (value) => ({
	type: Types.ADVENT_CALENDAR_SET_TERMS_MODAL,
	value,
});

const toggleSignInModal = (value) => ({
	type: Types.ADVENT_CALENDAR_SET_SIGNIN_MODAL,
	value,
});


const Actions = {
	closeNotification,
	addNotification,
    setCalendarModal,
	getMyGifts,
	getRecentGifts,
	saveUserGift,
	getTermsModal,
	toggleSignInModal,
}

export {Types, Actions}
